import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faExternalLinkAlt,
  faDesktop,
  faUsersCog,
  faMapMarkedAlt,
  faBook,
  faInfoCircle,
  faExclamationTriangle,
  faSitemap,
  faFire,
  faComments,
  faLanguage,
  faHashtag,
  faBoxOpen,
  faNewspaper,
  faStar,
  faChartLine,
  faDownload,
  faThumbsUp,
  faEye,
  faShapes,
  faCogs,
  faDraftingCompass,
  faChevronDown,
  faLink,
  faRetweet,
  faHeart,
  faSpinner,
  faTimes,
  faCheck,
  faExternalLinkSquareAlt,
  faUsers,
  faKeyboard,
  faSearch,
  faShieldAlt,
  faDotCircle,
  faPalette,
  faStream,
  faComment,
  faCalendarAlt,
  faFrown,
  faInfo,
  faTimesCircle,
  faRss,
  faUpload,
  faGamepad,
  faStore,
  faWallet,
  faColumns,
  faCloud,
  faLightbulb
} from '@fortawesome/free-solid-svg-icons'

import { faUserCircle, faComments as faCommentsReg } from '@fortawesome/free-regular-svg-icons'

import {
  faTwitter,
  faFacebookF,
  faGithub,
  faTumblr,
  faFlickr,
  faAppStoreIos,
  faGooglePlay
} from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faExternalLinkAlt, faDesktop, faUsersCog, faMapMarkedAlt, faBook, faInfoCircle, faExclamationTriangle,
  faSitemap, faFire, faComments, faLanguage, faHashtag, faBoxOpen, faNewspaper, faStar, faChartLine, faDownload,
  faThumbsUp, faEye, faShapes, faCogs, faDraftingCompass, faChevronDown, faLink, faRetweet, faHeart, faSpinner,
  faTimes, faCheck, faExternalLinkSquareAlt, faUsers, faKeyboard, faSearch, faShieldAlt, faDotCircle, faPalette, faStream, faComment,
  faCalendarAlt, faFrown, faInfo, faTimesCircle, faRss, faUpload, faGamepad, faStore, faWallet, faColumns, faCloud,
  faAppStoreIos, faGooglePlay, faLightbulb)

library.add(faUserCircle, faCommentsReg)

library.add(faTwitter, faFacebookF, faGithub, faTumblr, faFlickr)

Vue.component('font-awesome-icon', FontAwesomeIcon)
